import {useWatch} from 'react-hook-form';

import {useReadCodelistQuery} from '@dms/api/core';
import i18n from '@dms/i18n';

import {RentalVehicle} from '../../core/types/RentalVehicle';
import {useVehicleFormContext} from '../hooks/useVehicleFormContext';
import {Field} from './primitives/Field';

export function VehicleCategorySelect() {
  const {control} = useVehicleFormContext<RentalVehicle>();
  const vehicleCategoryId = useWatch({
    control,
    name: 'rentalProperties.vehicleCategoryId',
  });

  const {
    data: vehicleCategoryData,
    isLoading: isLoadingVehicleCategoryData,
    isError: isVehicleCategoryDataError,
  } = useReadCodelistQuery({codelistId: 'vehicleCategory'});

  const vehicleCategoryOptions =
    vehicleCategoryData?.codes
      ?.filter((item) => item.isDisabled === false || item.codeId === vehicleCategoryId)
      .map((code) => ({value: code.codeId, label: code.name})) || [];

  return (
    <Field<RentalVehicle, 'choice'>
      type="choice"
      name="rentalProperties.vehicleCategoryId"
      label={i18n.t('entity.rental.labels.vehicleCategory')}
      isNotClearable
      isLoading={isLoadingVehicleCategoryData}
      options={vehicleCategoryOptions}
      isDisabled={isVehicleCategoryDataError}
    />
  );
}
